import { render, staticRenderFns } from "./AddRecordOffline.vue?vue&type=template&id=241f376c&scoped=true&"
import script from "./AddRecordOffline.vue?vue&type=script&lang=js&"
export * from "./AddRecordOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f376c",
  null
  
)

export default component.exports